
// src/web/components/sub-group-timeline-page.jsx

import React from 'react'
import connect from '../../connects/sub-group-timeline-page'
import {
} from 'react-toolbox'
import RightSidePage from './right-side-page.jsx'

class SubGroupTimelinePage extends React.Component {
  render() {
    const {
      t,
    } = this.props

    return (
      <RightSidePage title='グループのタイムライン' icon="people">
      </RightSidePage>
    )
  }
}

export const RawSubGroupTimelinePage = SubGroupTimelinePage
export default connect(SubGroupTimelinePage)



// WEBPACK FOOTER //
// ./src/web/components/sub-group-timeline-page.jsx